import React from "react"

export const TourTag = ({tag}) => {
  const tagDisplayInfo = {
    'all seasons': {label:'All Seasons'},
    'spring': {label:'Spring', color: 'bg-pink-400', img: '/icons/tag-spring.svg'},
    'summer': {label:'Summer', color: 'bg-red-600', img: '/icons/tag-summer.svg'},
    'autumn': {label:'Autumn', color: 'bg-orange-400', img: '/icons/tag-autumn.svg'},
    'winter': {label:'Winter', color: 'bg-sky-500', img: '/icons/tag-winter.svg'},
    'book-online': {label:'Book Online', color: 'bg-blue-800', img: '/icons/tag-book-online.svg'},
    'customizable': {label:'Customizable', color: 'bg-green-800', img: '/icons/tag-customizable.svg'},
    'luxury': {label:'Luxury', color: 'bg-yellow-400', img: '/icons/tag-luxury.svg'},
    'Flight Package': {label:'Flight Package', color: 'bg-fuchsia-700', img: '/icons/tag-airplane.svg'},
  }

  return (
    <div className={`text-white text-xs flex rounded-lg shadow-[2px_2px_0px_0px_rgba(200,200,200,0.8)] px-2 py-1 mr-2 ${tagDisplayInfo[tag]?.color ? tagDisplayInfo[tag]?.color : 'bg-slate-700' }`}>
      { tagDisplayInfo[tag]?.img && <img className="w-[15px] h-[15px] mr-1" loading="lazy" src={tagDisplayInfo[tag]?.img} alt="Tag icon"/> }
      { tagDisplayInfo[tag] ? tagDisplayInfo[tag].label : tag }
    </div>
  )

}

export const TourTags = ({blok}) => {
  return (
    <div className="tags flex flex-wrap gap-1">
      {blok.season?.map((s, index) => ( <TourTag key={index} tag={s} /> ))}
      {blok.label?.value?.map((tag, index) => ( <TourTag key={index} tag={tag} /> ))}
    </div>
  )
}

export default TourTags